export const collator = new Intl.Collator("pt-BR", {
    sensitivity: "base",
    numeric: true,
    ignorePunctuation: true,
});

export const clean = (string) => (string ?? "").trim().replace(/\s+/g, " ");

export const toTime = (date) => new Date(date ?? 0).getTime();

export const strip = (string) => clean(String(string ?? '')).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();